import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

interface RelatedNewsProps {
  currentId: string;
  category: string;
  title?: string;
}

export default function RelatedNews({ currentId, category, title = "相关推荐" }: RelatedNewsProps) {
  const sameCategory = newsList.filter((item) => item.category === category && item.id !== currentId);
  const fallback = newsList.filter((item) => item.id !== currentId && item.category !== category);
  const items = [...sameCategory, ...fallback].slice(0, 3);

  return (
    <section aria-label={title} className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
        <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-links-line text-sm" aria-hidden="true"></i>
        </span>
        {title}
      </h2>
      <ul className="mt-4 space-y-1">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={`/news/${item.id}`}
              className="group flex items-start gap-3 border-b border-background-100 py-3 last:border-b-0"
            >
              <span className="mt-0.5 text-[11px] text-foreground-400">{item.category}</span>
              <span className="line-clamp-2 flex-1 text-[13px] leading-6 text-foreground-800 transition-colors group-hover:text-primary-700">
                {item.title}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}